import { createModuleLayout } from "@/lib/create-module-layout";
import { MODULES } from "@kubdee/shared/module-ids";
import fleetModule from "@kubdee/module-fleet";

export default createModuleLayout({
  moduleId: MODULES.FLEET,
  moduleConfig: fleetModule,
});
